// Find all style tags containing [js-id=] and add corresponding hidden divs
document.addEventListener('DOMContentLoaded', function() {
  // Find all style tags
  const styleTags = document.querySelectorAll('style');
  
  styleTags.forEach(function(styleTag) {
    const styleContent = styleTag.textContent || styleTag.innerText;
    
    // Check if the style content contains [js-id=
    if (styleContent.includes('[js-id=')) {
      // Extract the js-id value using regex
      const match = styleContent.match(/\[js-id=["']?([^"'\]]+)["']?\]/);
      
      if (match && match[1]) {
        const jsId = match[1];
        const parentContainer = styleTag.parentElement;
        
        if (parentContainer) {
          // Check if a div with this ID already exists in the parent
          const existingDiv = parentContainer.querySelector(`#${jsId}`);
          
          if (!existingDiv) {
            // Create a new anchor div for hash links
            const anchorDiv = document.createElement('div');
            anchorDiv.id = jsId;
            // Make it invisible but keep it in the document flow for hash links
            anchorDiv.style.cssText = 'height: 0; width: 0; margin: 0; padding: 0; overflow: hidden; visibility: hidden;';
            
            // Insert as the first child of the parent container
            parentContainer.insertBefore(anchorDiv, parentContainer.firstChild);
          }
        }
      }
    }
  });
});
// Close drawer when clicking hash links in mega navigation
document.addEventListener('DOMContentLoaded', function() {
  // Add click event listener to all mega nav links with hash hrefs
  document.addEventListener('click', function(event) {
    const target = event.target.closest('a.wt-page-nav-mega__link');
    
    if (target && target.href && target.getAttribute('href').startsWith('/#')) {
      // Only close drawer if menu is currently open
      if (document.body.classList.contains('menu-open')) {
        const drawerClose = document.querySelector('.wt-drawer__close');
        
        if (drawerClose) {
          drawerClose.click();
        }
      }
    }
  });
});

// Round up donation function - global scope so it's always available
window.addRoundUpDonation = function(button) {
  const variantId = button.dataset.variantId;
  const widget = document.getElementById('cart-round-up-widget');
  
  button.disabled = true;
  button.textContent = 'adding...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  })
  .catch(error => {
    console.error('Error adding donation:', error);
    button.disabled = false;
    button.textContent = 'Yes, round up';
  });
};
